import { Component, OnInit, Input } from '@angular/core';
import { Breakdown } from 'src/app/model/quote/breakdown/breakdown.model';

@Component({
  selector: 'app-breakdown-drivers-view',
  templateUrl: './breakdown-drivers-view.component.html',
  styleUrls: ['./breakdown-drivers-view.component.css']
})
export class BreakdownDriversViewComponent implements OnInit {
  quote;
  quoteApplicationData = new Breakdown();
  CoverTo;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.quoteApplicationData = value.application;
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
